import { Box, Stack, Typography } from '@mui/material';
import { PUBLIC_APPBAR_HEIGHT } from '../../../../layout/public-layout/navigation/Navigation';

import EbookImg from '../../../../assets/img/public-pages/innovative-agency-growth-strategies.png';
import CheckedItem from '../../Pricing/components/PlanDetails/components/CheckedItem';
import DownloadForm from './DownloadForm';

const SponaInfobip = () => (
  <Stack
    spacing={12.5}
    direction="column"
    alignItems="center"
    sx={{
      marginTop: `${PUBLIC_APPBAR_HEIGHT + 80}px`,
      marginBottom: { xs: '10rem' },
      overflow: 'hidden',
      mx: 'auto',
      maxWidth: '1440px',
      width: '100%',
      px: { xs: '16px', md: '32px', gr: '80px' },
    }}
  >
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ px: '138px' }}
      gap={0}
    >
      <Typography variant="publicBody3Regular" color="primaryLight.500" sx={{ mb: 1 }}>
        Free Download
      </Typography>
      <Typography
        variant="publicHeading2"
        textAlign="center"
        sx={{ mb: 3, fontSize: { xs: '3rem', sm: '4rem' } }}
      >
        Your Clients Are Messaging. Are You Ready?
      </Typography>
      <Typography variant="publicBody2Regular" textAlign="center" sx={{ mb: 5 }}>
        This free eBook is your guide to how digital agencies are scaling faster, building stronger
        client relationships, and staying ahead by adopting the conversational age.
      </Typography>

      <DownloadForm />
    </Stack>

    <Stack
      direction={{ xs: 'column', bg: 'row' }}
      alignItems="center"
      spacing={10}
      justifyContent="space-between"
      sx={{ width: '100%' }}
      overflow="hidden"
    >
      <Box
        component="img"
        src={EbookImg}
        alt="Innovative Agency Growth Strategies e-book cover"
        sx={{
          maxWidth: { xs: '471px', sm: '628px' }, //470 628
          maxHeight: { xs: '425px', sm: '566px' }, //425px 566
          borderRadius: '12px',
        }}
      />
      <Stack direction="column" gap={3} sx={{ mt: { xs: '4rem', bg: 0 } }}>
        <Typography variant="publicHeading4" sx={{ mb: '1rem' }}>
          In this ebook you'll learn:
        </Typography>
        <CheckedItem title="How to move from traditional engagement to real-time, multi-platform communication." />
        <CheckedItem title="The 3 core pillars of conversational experience: marketing, support and commerce" />
        <CheckedItem title="How to use channels like WhatsApp, Messenger & Instagram to promote growth" />
        <CheckedItem title="Real-life case studies from LAQO & Podravka" />
        <CheckedItem title="Tips to future-proof your agency strategy with messaging and AI" />
      </Stack>
    </Stack>
  </Stack>
);

export default SponaInfobip;
